import { Directive, Input } from '@angular/core';
import { normalizeWebsiteLink } from 'src/app/common/app.helpers';
import { EntityStatus } from 'src/app/interfaces/views.interface';
import { Project } from 'src/app/swagger-api';
import { CommunityView } from '../../community/communities-store';
import { MapFilters } from '../../map/map.enum';
import { getLocation } from '../../map/shared/location.service';
import { getStatus } from '../../profile/user-profile/view-profile/regular-user-profile/regular-user-profile-helper';

@Directive()
export class SocialInitiativeInfoComponentShared<T extends CommunityView | Project> {
  @Input({ required: true }) public entity: T;

  public readonly mapFilters = MapFilters;

  public get location(): string {
    return getLocation(this.entity.location);
  }

  public get status(): EntityStatus {
    return getStatus(this.entity.creator);
  }

  public get normalizedLink(): string {
    return normalizeWebsiteLink(this.entity.website);
  }
}
